import pluralize from "pluralize";

import { getReadableAggregationMethod } from "../../../utils/DashboardUtils";

interface Props {
  aggregationField: string;
  aggregationMethod: string;
  aggregationFieldName: string;
  groupByField: string;
  groupByFieldName: string;
  moduleName: string;
  [key: string]: any;
}

export default function ChartTooltip({
  aggregationField,
  aggregationMethod,
  aggregationFieldName,
  groupByField,
  groupByFieldName,
  moduleName,
  ...props
}: Props) {
  if (props.active && props.payload && props.payload.length) {
    if (aggregationFieldName === "id") {
      aggregationFieldName = moduleName;
    }

    const item = props.payload[0];
    let header = `${getReadableAggregationMethod(
      aggregationMethod
    )} of ${pluralize(aggregationFieldName || groupByFieldName || "")}`;
    let value =
      groupByField === "Tags"
        ? item?.payload?.Name
        : item?.payload?.[groupByField];

    return (
      <div className="bg-white rounded-sm px-4 py-2 border">
        <h5 className="mb-0">{header}</h5>
        <div className="d-flex align-items-center">
          {item?.payload?.fill && (
            <div
              className="rounded-sm"
              style={{
                height: 18,
                width: 18,
                backgroundColor: item?.payload?.fill,
                marginRight: 10,
              }}
            ></div>
          )}
          <p className="my-0 text-sm">
            <span className="font-weight-500 text-dark">
              {value || `No ${groupByFieldName}`}
            </span>
            :{" "}
            <span className="font-weight-600">
              {item?.payload?.readable ??
                (typeof item?.value === "object" && item?.value !== undefined
                  ? item?.value?.Symbol + item?.value?.Value
                  : item?.value)}
            </span>
          </p>
        </div>
      </div>
    );
  }

  return null;
}
